// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M15.4142 1H3V23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5ZM9.29305 18.2072L6.08594 15.0001L9.29304 11.793L10.7073 13.2072L8.91437 15.0001L10.7073 16.793L9.29305 18.2072ZM13.2929 16.793L15.0858 15.0001L13.2929 13.2072L14.7071 11.793L17.9142 15.0001L14.7071 18.2072L13.2929 16.793Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-file-code-1-filled')
export default class FileCode1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-code-1-filled',
    }
  }
}
